/* eslint-disable import/prefer-default-export */
export const arrayToURL = array => {
  if (!array?.length) {
    return null;
  }
  return encodeURIComponent(JSON.stringify(array));
};
